import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header bg-primary d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "header-start" }
const _hoisted_3 = {
  key: 1,
  class: "text-light small fw-bold"
}
const _hoisted_4 = { class: "header-title text-light m-0" }
const _hoisted_5 = { class: "header-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.canGoBack)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "header-action",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBack()))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fa fa-long-arrow-alt-left text-light" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.version), 1))
      ]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.$route.name === 'Buildings')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "header-action",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLogout()))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fa fa-door-open text-light" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "header-action",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHome()))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fa fa-home text-light" }, null, -1)
            ]))]))
      ])
    ]),
    (_ctx.isOffline)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.offlineModeIsPermitted)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.hasPendingChanges)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      class: "offline-alert",
                      title: "App is running in offline mode.",
                      type: "info",
                      closable: false
                    }))
                  : (_ctx.hasPendingChanges)
                    ? (_openBlock(), _createBlock(_component_el_alert, {
                        key: 1,
                        class: "offline-alert",
                        title: `You have ${_ctx.pendingChangesCount} unsaved changes. re-establish connectivity to save.`,
                        type: "warning",
                        closable: false
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_el_alert, {
                key: 1,
                class: "offline-alert",
                title: "You are offline. An internet connection is required for correct operation.",
                type: "error",
                closable: false
              }))
        ], 64))
      : (_ctx.hasPendingChanges)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 1,
            class: "offline-alert",
            title: `Saving ${_ctx.pendingChangesCount} changes...`,
            type: "warning",
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
  ], 64))
}